module.exports = __webpack_public_path__ + "img/gigabox.ce37244d.png";